import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/makes.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { Make } from "@/types/make";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for makes
  const mock = AxiosMock.getInstance();
  mock.onGet("/carburate/market/makes/").reply(200, data);
}

export const getMarketMakes = async () => {
  return api.get("/carburate/market/makes/") as Promise<Make[]>;
};

export const getMarketMakesQueryOptions = () => {
  return queryOptions({
    queryKey: ["market", "makes"],
    queryFn: getMarketMakes,
  });
};

type UseMarketMakesOptions = {
  queryConfig?: QueryConfig<typeof getMarketMakes>;
};

/* const TEMPORARY_FILTERED_MAKES = ["Bugatti", "Lamborghini", "Ferrari"]; */

export const useMarketMakes = ({ queryConfig }: UseMarketMakesOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getMarketMakesQueryOptions(),
    ...queryConfig,
    /*     select: (data) => data.filter((make) => TEMPORARY_FILTERED_MAKES.includes(make.name)), */
  });
};
